import {
    container,
    mrAuto,
    mlAuto,
    description
} from "../../../material-kit-pro-react.jsx";

const descriptionStyle = {
    container,
    textCenter: {
        textAlign: "center"
    },
    textJustified: {
        textAlign: "justify",
        padding: '30px'
    },
    aboutDescription: {
        padding: "70px 0 0 0"
    },
    kidsAdvice: {
        padding: "70px 0 70px 0"
    },
    mrAuto,
    mlAuto,
    description,
    focusedContainer: {
        border: '3px solid palegreen',
        borderRadius: '5px'
    }
};

export default descriptionStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx